import { render, staticRenderFns } from "./XsollaWidget.vue?vue&type=template&id=6c7324ec&"
import script from "./XsollaWidget.vue?vue&type=script&lang=ts&"
export * from "./XsollaWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports